// extracted by css-extract-rspack-plugin
export default {"cards-wrapper":"BiddingStrategySelect-module__cards-wrapper--YXfLc","cardsWrapper":"BiddingStrategySelect-module__cards-wrapper--YXfLc"};